import React, { useState, useEffect } from "react";
import {
  Space,
  Row,
  Col,
  InputNumber,
  Form,
  Input,
  Button,
  message,
  Switch
} from "antd";
import DatePicker from "@general/datePicker";
import UploadFile from "@general/UploadFile";
import { gql, useMutation } from "@apollo/client";
import DeleteIncome from "@general/deleteSideIncome";
const UPDATEINCOME = gql`
  mutation updateIncome($updateInput: UpdateIncomeInput!, $id: ID!) {
    updateIncome(updateInput: $updateInput, id: $id)
  }
`;

function SideIncomesForm({ formData, incomeId, onDoUpdateData }) {
  const [form] = Form.useForm();
  const [error, setError] = useState(null);
  const [editable, setEditable] = useState(false);

  const [runUpdateIncome, updateIncome] = useMutation(
    UPDATEINCOME,
    {
      onCompleted() {
        message.success("درآمد بروزرسانی شد.");
        onDoUpdateData();
      },
      onError(err) {
        console.log("خطا: " + err.message);
        message.error("مشکلی پیش آمده! درآمد بروزرسانی نشد.");
      },
    }
  );

  useEffect(() => {
    form.setFieldsValue(formData);
  }, [formData]);

  const doUpdateIncome = (updateInput) => {
    runUpdateIncome({
      variables: {
        id: incomeId,
        updateInput: {
          ...updateInput,
          amount: parseInt(updateInput.amount),
        },
      },
    });
  };

  return (
    <>
      <Row>
        <Space align>
          <p>ویرایش: </p>
          <Switch onChange={() => setEditable(!editable)} />
        </Space>
      </Row>{" "}
      <Form
        layout="vertical"
        onFinish={doUpdateIncome}
        form={form}
        disabled={!editable}
      >
        <Row gutter={20}>
          <Col xs={24} md={12}>
            <Form.Item
              name="amount"
              id="amount"
              label="مبلغ درآمد (ریال)"
              decimalSeparator
              rules={[
                {
                  required: true,
                  message: "لطفا درآمد را وارد کنید!",
                },
                {
                  pattern: /^[0-9]*$/,
                  message: "لطفا درآمد را به طور صحیح وارد کنید",
                },
              ]}
            >
              <InputNumber
                formatter={(value) =>
                  value?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || ""
                }
                parser={(value) => value?.replace(/\$\s?|(,*)/g, "") || ""}
                className="form-input"
                placeholder={"مبلغ درآمد"}
                style={{ textAlign: "left", width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              label="بابت (توضیحات)"
              name="description"
              rules={[{ required: true, message: "این فیلد ضروری است" }]}
            >
              <Input.TextArea rows={2} placeholder="توضیحات" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="تاریخ وقوع"
              name="occurrenceAt"
              rules={[{ required: true, message: "این فیلد ضروری است" }]}
            >
              <DatePicker
                showToday={false}
                format="YYYY/MM/DD"
                className="rtl"
                placeholder="تاریخ وقوع"
              />
            </Form.Item>
            <Form.Item
              name="documentImg"
              label="تصویر سند"
              validateStatus={error && "error"}
            >
              <UploadFile square />
            </Form.Item>
          </Col>
        </Row>
        <Space style={{ marginTop: "20px" }}>
        <Button type="primary" htmlType="submit"  loading={updateIncome.loading && true}>
          ثبت
        </Button>
        <DeleteIncome
            id={incomeId}
            onDeleteIncome={onDoUpdateData}
          >
             <Button danger type="text">
              حذف درآمد
            </Button>
          </DeleteIncome>
        </Space>
      </Form>
    </>
  );
}

export default SideIncomesForm;
